import useRequest, { IDataRequest } from '@hooks/useRequest';
import { ICaixa } from '@model/Caixa';
import {ICaixaItem} from '@model/CaixaItem';
import ICaixaTipoLancamento, { EnumCaixaTipoLancamento } from '@model/CaixaTipoLancamento';
import React from 'react';

export interface ICaixaItemRecord extends ICaixaItem {
    saldo: number
}
 export interface ICaixaImpressaoResponse {
    nome: string
    periodoDe: Date
    periodoAte: Date
    itens: ICaixaItemRecord[]
}

export interface ICaixaRegistrarRequest {
    descricao: string
    valor: number
}

export interface ICaixaFilter {
    caixaId?: number
    competencia?: string
}

export interface ICaixaDescricaoFilter {
    descricao?: string
}

const controller = "Caixa";

export function useCaixaService () {
    const _request = useRequest();

    const listar = React.useCallback((filter: ICaixaFilter) => {
        return _request.get<ICaixaItemRecord[]>(`${controller}/Listar`, {
            params: filter
        });
    }, [_request]);
    
    const pesquisarDescricao = React.useCallback((filter: IDataRequest<ICaixaDescricaoFilter>) => {
        return _request.getData<ICaixaItemRecord[]>(`${controller}/PesquisarDescricao`, filter);
    }, [_request]);

    const carregarCaixaImpressao = React.useCallback((periodoDe: Date, periodoAte: Date, caixaId?: number) => {
        const caixaIdParam = (caixaId !== undefined ? `/${caixaId}` : "");

        return _request.get<ICaixaImpressaoResponse>(`${controller}/CarregarCaixaParaImpressao${caixaIdParam}`, {
            params: {
                periodoDe, 
                periodoAte
            }
        });
    }, [_request]);

    const listarAtivos = React.useCallback(() => {
        return _request.get<ICaixa[]>(`${controller}/ListarAtivos`);
    }, [_request]);

    const listarPorData = React.useCallback((data: Date) => {
        return _request.get<ICaixaItemRecord[]>(`${controller}/ListarPorData/${data.toDateString()}`);
    }, [_request]);

    const listarTiposLancamentoAtivos = React.useCallback(() => {
        return _request.get<ICaixaTipoLancamento[]>(`${controller}/ListarTiposLancamentosAtivos`);
    }, [_request]);

    const registrar = React.useCallback((caixaTipoLancamentoId: EnumCaixaTipoLancamento, request: ICaixaRegistrarRequest) => {
        return _request.post<ICaixaItem>(`${controller}/Registrar/${caixaTipoLancamentoId}`, request)
    }, [_request]);

    return React.useMemo(() => ({
        listar, listarAtivos, carregarCaixaImpressao, listarPorData, listarTiposLancamentoAtivos, registrar, pesquisarDescricao
    }), [listar, listarAtivos, carregarCaixaImpressao, listarPorData, listarTiposLancamentoAtivos, registrar, pesquisarDescricao]);
}